/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import stickerData from 'data/sticker.json';
import Headline from 'headline';
import Img from 'img';
import Icon from 'icon';
import { navigate } from 'gatsby';
import { qualityColor } from 'utils/helpers';
import Swiper from 'react-id-swiper';
import 'swiper/dist/css/swiper.css';
import s from './infl-sticker.module.scss';

function InfluencerStickerSlider(props) {
  const [renderSlider, setSlider] = useState(false);
  const [renderImages, setImages] = useState(false);
  const [randomizedData, setRandomizedData] = useState(null);
  const [swiper, updateSwiper] = useState(null);
  const { white } = props;
  const whiteClass = white ? s.white : '';

  const params = {
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    speed: 4000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    renderPrevButton: () => <div className={`${s.arrowWrapper} ${s.prev} swiper-button-prev`}><Icon icon="chevron-left" /></div>,
    renderNextButton: () => <div className={`${s.arrowWrapper} ${s.next} swiper-button-next`}><Icon icon="chevron-right" /></div>,
    ContainerEl: 'ul',
    containerClass: `${s.list}`,
    slidesPerView: 5,
    loop: true,
    freeMode: true,
    freeModeFluid: true,
    grabCursor: true,
    shouldSwiperUpdate: true,
    preloadImages: false,
    lazy: true
  };

  const handleMouseOver = () => {
    swiper.params.speed = 1000;
    swiper.autoplay.stop();
  };

  const handleMouseOut = () => {
    swiper.params.speed = 4000;
    swiper.autoplay.start();
  };

  useEffect(() => {
    setTimeout(() => {
      setSlider(true);
    }, 1000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setImages(true);
    }, 1500);
  }, []);


  useEffect(() => {
    setRandomizedData([
      ...stickerData
        .filter(
          ({
            firstName,
            lastName,
            username,
            qualityScore,
            country,
            featuredImage
          }) =>
            firstName &&
            lastName &&
            username &&
            qualityScore &&
            country &&
            featuredImage
        )
        .sort(() => 0.5 - Math.random())
        .slice(0, 30)
    ]);
  }, []);


  return (
    <>
      {renderSlider === true ? (
        <section
          className={`${s.root} ${whiteClass}`}
        >
          <style dangerouslySetInnerHTML={{
            __html:
              `.swiper-wrapper {
              transition-timing-function:linear;
            }`
          }}
          />
          <div
            className={s.wrapper}
            onMouseOver={() => { handleMouseOver(); }}
            onMouseOut={() => { handleMouseOut(); }}
            onBlur={() => void 0}
            onFocus={() => void 0}
          >
            <div className={s.listWrapper}>
              {randomizedData !== null ? (
                <Swiper {...params} getSwiper={updateSwiper}>
                  {randomizedData.map(
                    ({
                      firstName,
                      lastName,
                      username,
                      qualityScore,
                      country,
                      featuredImage
                    }) => {
                      return (
                        <li
                          key={username}
                          className={s.card}
                          onClick={() =>
                            navigate(`/influencers/${username.replace('@', '')}`)
                          }
                        >
                          <div className={`${s.imgWrapper} swiper-lazy`}>
                            {renderImages ? (
                              <Img
                                className={s.image}
                                src={featuredImage ?.id}
                                alt={featuredImage ?.id}
                              />
                            ) : ''}
                          </div>

                          <div
                            className={s.infoWrapper}
                          >
                            <Headline
                              className={s.title}
                              h6="true"
                              secondary
                              el="a"
                              href={`/influencers/${username.replace('@', '')}`}
                            >
                              {`${firstName.split('/')[0]} ${lastName.split('/')[0]}`}
                            </Headline>
                            <div
                              className={s.item}
                            >
                              <Icon icon="link" />
                              @
                                 {username}
                            </div>
                            <div
                              className={s.item}
                            >
                              <Icon icon="location-small" />
                              {country ?.name}
                            </div>
                          </div>
                          <div
                            className={`${s.quality} ${
                              s[qualityColor(qualityScore)]
                              }`}
                          >
                            {qualityScore}
                            <span>of 100</span>
                          </div>
                        </li>
                      );
                    }
                  )}
                </Swiper>
              )
                :
                ''}
            </div>
          </div>
        </section>
      )
        :
        ''
      }
    </>
  );
}

export default React.memo(InfluencerStickerSlider);
